import * as React from 'react';
import styled from 'styled-components';
import {mixinBtnLarge, mixinResetBtnCss, mixinBtnCorporate, mixinWithBtnPropsFn, IBtnDefaultProps} from "./btn_mixin";

interface IProps
    extends IBtnDefaultProps, React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
}

const BtnCorporateLargeDefault: React.FC<IProps> = (props) => {

    const { icon, widthSize, ...ButtonProps } = props;

    return (<button {...ButtonProps} />)

};

const BtnCorporateLarge = styled(BtnCorporateLargeDefault)`
    ${mixinResetBtnCss}
    ${mixinBtnLarge}
    ${mixinBtnCorporate}
    
    ${props => mixinWithBtnPropsFn(props)}
`;

export default BtnCorporateLarge;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/btn/btn_corporate_large.tsx